import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana66Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
  <svg 
    width={style?.width || "1219"}
    height={style?.height || "941"}
    viewBox="0 0 1221 921" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
    <rect width="1221" height="921" fill="url(#pattern0_1465_19731)"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("13"))}
      d="M219.569 743.105L233.43 711.221L281.95 730.629L269.474 761.127L229.273 759.741C218.183 756.413 218.183 747.264 219.569 743.105Z" 
      fill={getFillByLot(13, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("14"))}
      d="M329.081 763.902L269.471 761.129L288.879 718.154L349.875 744.494L344.412 757.605C343.451 759.912 341.944 762.082 339.592 762.93C336.014 764.219 332.23 763.902 329.081 763.902Z" 
      fill={getFillByLot(14, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("15"))}
      d="M363.74 711.222L349.877 744.493L288.881 718.154L302.744 684.883L363.74 711.222Z" 
      fill={getFillByLot(15, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("16"))}
      d="M377.603 676.564L363.741 711.221L302.744 684.882L316.607 650.225L377.603 676.564Z" 
      fill={getFillByLot(16, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("17"))}
      d="M391.469 643.294L377.606 676.565L316.609 650.226L330.472 616.955L391.469 643.294Z" 
      fill={getFillByLot(17, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("12"))}
      d="M251.451 668.246L233.43 711.221L283.336 730.629L299.971 690.427L251.451 668.246Z" 
      fill={getFillByLot(12, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("11"))}
      d="M266.704 628.043L251.455 668.245L299.975 690.426L316.61 648.837L266.704 628.043Z" 
      fill={getFillByLot(11, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("18"))}
      d="M405.332 610.019L391.469 643.29L330.473 616.95L344.335 583.68L405.332 610.019Z" 
      fill={getFillByLot(18, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("19"))}
      d="M419.195 576.751L405.332 610.022L344.336 583.682L358.199 549.025L419.195 576.751Z" 
      fill={getFillByLot(19, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("20"))}
      d="M433.056 542.097L419.194 576.754L358.197 549.029L372.06 515.758L433.056 542.097Z" 
      fill={getFillByLot(20, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("10"))}
      d="M283.337 586.455L266.701 628.044L316.607 648.838L333.243 608.636L283.337 586.455Z" 
      fill={getFillByLot(10, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("9"))}
      d="M301.359 546.254L283.337 586.456L333.243 608.637L349.878 568.434L301.359 546.254Z" 
      fill={getFillByLot(9, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("8"))}
      d="M317.993 506.051L301.357 546.253L349.877 568.433L366.513 526.845L317.993 506.051Z" 
      fill={getFillByLot(8, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("21"))}
      d="M446.922 508.824L433.059 542.094L372.062 515.755L385.925 482.484L446.922 508.824Z" 
      fill={getFillByLot(21, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("22"))}
      d="M460.781 475.556L446.918 508.827L385.922 482.488L399.785 449.217L460.781 475.556Z" 
      fill={getFillByLot(22, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("7"))}
      d="M334.628 464.463L317.992 506.051L366.512 526.846L384.534 485.257L334.628 464.463Z" 
      fill={getFillByLot(7, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("6"))}
      d="M351.263 424.26L334.628 464.462L384.534 485.256L401.169 445.054L351.263 424.26Z" 
      fill={getFillByLot(6, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("23"))}
      d="M474.646 440.896L460.783 475.553L399.787 449.214L413.65 414.557L474.646 440.896Z" 
      fill={getFillByLot(23, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("24"))}
      d="M488.508 409.015L474.645 440.899L413.648 414.56L428.898 381.289L488.508 409.015Z" 
      fill={getFillByLot(24, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("25"))}
      d="M502.365 375.74L488.502 409.01L428.892 381.285L442.754 349.4L502.365 375.74Z" 
      fill={getFillByLot(25, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("26"))}
      d="M517.623 341.083L502.374 375.741L442.764 349.401L456.626 314.744L517.623 341.083Z" 
      fill={getFillByLot(26, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("27"))}
      d="M531.484 307.816L517.621 341.087L456.625 314.747L469.102 281.477L531.484 307.816Z" 
      fill={getFillByLot(27, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("28"))}
      d="M545.346 273.156L531.483 307.813L469.101 281.473L482.963 246.816L545.346 273.156Z" 
      fill={getFillByLot(28, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("29"))}
      d="M559.205 239.884L545.343 273.155L482.96 246.816L496.823 213.545L559.205 239.884Z" 
      fill={getFillByLot(29, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("30"))}
      d="M575.844 201.07L559.209 239.886L496.826 213.546L554.777 185.245C555.877 184.708 557.057 184.33 558.273 184.19C578.615 181.843 578.538 194.335 575.844 201.07Z" 
      fill={getFillByLot(30, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}
      d="M424.739 248.202L496.826 213.545L467.714 282.859L419.194 262.065L424.739 248.202Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("5"))}
      d="M367.901 382.674L351.266 424.262L401.172 445.056L417.807 404.854L367.901 382.674Z" 
      fill={getFillByLot(5, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("4"))}
      d="M384.537 342.473L367.901 382.675L417.807 404.855L435.829 364.653L384.537 342.473Z" 
      fill={getFillByLot(4, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("3"))}
      d="M402.556 302.268L384.534 342.47L435.827 364.65L452.462 324.448L402.556 302.268Z" 
      fill={getFillByLot(3, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("2"))}
      d="M419.193 262.064L402.558 302.267L452.464 324.447L467.713 282.859L419.193 262.064Z" 
      fill={getFillByLot(2, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <defs>
      <pattern 
        id="pattern0_1465_19731" 
        patternContentUnits="objectBoundingBox" 
        width="1" 
        height="1">
        <use href="#image0_1465_19731" transform="matrix(0.00190152 0 0 0.0025209 -2.71876 -2.19056)"/>
      </pattern>
      <image
        id="image0_1465_19731"
        width="4096"
        height="2304"
        href="/mz2.png"
      />
    </defs>
  </svg>
  );
};
